import { readStoredJson } from '@/utils/storage';

const storedAccount = readStoredJson('admin_selectedAccount');
const activeAccount = storedAccount && typeof storedAccount === 'object' && storedAccount.id
  ? storedAccount
  : null;
const storedUsergroup = readStoredJson('admin_selectedUsergroup');
const activeUsergroup = storedUsergroup &&
  typeof storedUsergroup === 'object' &&
  typeof storedUsergroup.name === 'string'
  ? storedUsergroup
  : null;

export default {
  accounts: [],
  activeAccount,
  usergroups: [],
  activeUsergroup,
};
